import { render, staticRenderFns } from "./Medicines.vue?vue&type=template&id=7cfa64b5&scoped=true&"
import script from "./Medicines.vue?vue&type=script&lang=js&"
export * from "./Medicines.vue?vue&type=script&lang=js&"
import style0 from "./Medicines.vue?vue&type=style&index=0&id=7cfa64b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfa64b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VTextField,VTooltip})
